export default __webpack_public_path__ + "static/media/profit_pie.83e58436.svg";